import { Component, Input } from '@angular/core';
import { RrhhUnifyList } from 'src/app/models/rrhh.model';
import { TableHeader } from 'src/app/models/tableheader.model';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-rrhh-unify-tab',
  templateUrl: './rrhh-unify-tab.component.html',
  styleUrls: ['./rrhh-unify-tab.component.scss'],
})
export class RrhhUnifyTabComponent {
  @Input() tableHeader: TableHeader[] = [];
  @Input() unifyList: RrhhUnifyList[] = [];
  @Input() userCurrency = '';

  constructor(private readonly utils: UtilsService) {}

  formatNumber(n: any): string {
    return this.utils.processNumberAddDotFormat(n);
  }
}
